import React, { Component, useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { DatePicker } from "@material-ui/pickers";
import { setactiveTabObj } from "../../redux/actions/appActions";
import { connect } from "react-redux";
import swal from "sweetalert";
import { useHistory, withRouter, Route, Redirect, Switch } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OffileDb from '../../config/pouchDB';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined';
import Loader from "../loaders/loader";
import Questionnaire from "./Questionnaire";
import Calendardatepickerpopup from "./Calendardatepickerpopup.js";
import Calendartimepicker from "./Calendartimepicker.js";
import moment from 'moment';

var tempDates = [];
class UserSpecificCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      Date: new Date(),
      title: '',
      startdDate: new Date(),
      endDate: new Date(),
      time: new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
      frequency: 'Daily',
      description: '',
      editFlag: false
    };
  }


  componentDidMount() {
    OffileDb.setDatabase()
    if (this.props.editRemainderObj != null) {
      this.callEditMode(this.props.editRemainderObj)
    }
  }

  callEditMode(obj) {
    this.setState({
      editFlag: true,
      Date: obj.date,
      title: obj.title,
      startdDate: new Date(obj.startdDate),
      endDate: new Date(obj.endDate),
      time: obj.time,
      frequency: obj.frequency,
      description: obj.description,
    })
  }

  onDateChange = (date, str) => {
    console.log(date)
    if (str == 'start') {
      this.setState({ startdDate: date })
    } else {
      this.setState({ endDate: date })
    }
  };

  onTimeChange = (time) => {
    console.log(time)
    this.setState({ time: time })
  };

  handleTextFieldChange = (e) => {
    this.setState({
      title: e.target.value
    });
  }

  // handleTextpillchanges = (e) => {
  //   this.setState({
  //     pillName: e.target.value
  //   });
  // }

  handleTextDescriptionChange = (e) => {
    this.setState({
      description: e.target.value
    });
  }


  handleFrequencyChange = (e) => {
    console.log(e.target.value)
    this.setState({
      frequency: e.target.value
    });
  }

  setReminder() {
    const { t } = this.props;
    var that = this;
    var reminderJson = {
      "id": that.state.editFlag ? this.props.editRemainderObj.id : Math.floor(Math.random() * (10000 - 1) + 1),
      "date": this.state.Date,
      "title": this.state.title,
      "startdDate": this.state.startdDate,
      "endDate": this.state.endDate,
      "time": this.state.time,
      "description": this.state.description,
      "frequency": this.state.frequency,
    }

    if (this.state.title == '') {
      this.alertError("Please give a title to your reminder.")
    } else if (this.state.startdDat == '') {
      this.alertError("Please set a start date")
    } else if (this.state.endDate == '') {
      this.alertError("Please set a end date")
    } else if (this.state.time == '') {
      this.alertError("Please set a reminder time")
    } else {
      var validDates = this.validateCalendar();
      if (validDates) {
        swal({
          text: that.state.editFlag ? ("Are you sure want to update this reminder") : t("Are you sure want to save this reminder"),
          icon: "success",
          buttons: {
            confirm: {
              text: t("yes"),
              value: true,
              visible: true,
              className: "",
              closeModal: true
            },
            cancel: {
              text: t("no"),
              value: false,
              visible: true,
              className: "",
              closeModal: true,
            }
          }
        }).then((val) => {
          console.log(val)
          if (val) {
            OffileDb.getData('userReminderList').then(function (result) {
              if (that.state.editFlag) {
                that.updateRemiderToDB(reminderJson, result)
              } else {
                that.setRemiderToDB(reminderJson, result)
              }
            })
          }
        });
      }
    }
  }

  updateRemiderToDB(reminderJson, result) {
    if (!result.status && result.status != 400) {
      var store = result.data.filter(obj => obj.id != reminderJson.id)
      store.push(reminderJson)
      this.triggerReminder(reminderJson)
      OffileDb.setData('userReminderList', store)
      setTimeout(() => {
        this.props.onSaveChange()
      }, 500)
     
    }
  }

  setRemiderToDB(reminderJson, result) {
    if (!result.status && result.status != 400) {
      var store = result.data
      store.push(reminderJson)
    } else {
      var store = [reminderJson]
    }
    this.triggerReminder(reminderJson)
    OffileDb.setData('userReminderList', store)
    setTimeout(() => {
      this.props.onSaveChange()
    }, 500)
  }

  triggerReminder = (reminderJson) => {
    if (window.cordova) {
      console.log(reminderJson)
      var t = reminderJson.time.split(":");
      var hour = parseInt(t[0]);
      var min = parseInt(t[1]);
      var pillDates = this.getAllRemiderDates(reminderJson)
      if (pillDates && pillDates.length > 0) {
        pillDates.forEach(element => {
          window.cordova.plugins.notification.local.hasPermission(function (granted) {
            if (granted == true) {
              window.cordova.plugins.notification.local.schedule({
                title: reminderJson.title,
                text: reminderJson.description,
                trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }

              });
            } else {
              window.cordova.plugins.notification.local.requestPermission(function (granted) {
                if (granted == true) {
                  window.cordova.plugins.notification.local.schedule({
                    title: reminderJson.title,
                    text: reminderJson.description,
                    trigger: { at: new Date((new Date(element)).getFullYear(), (new Date(element)).getMonth(), (new Date(element)).getDate(), hour, min) }
                  });
                }
              });
            }
          });
        });
      }
    }
  }

  getAllRemiderDates(reminderJson) {
    var tempDates = []
    var startday = new Date(reminderJson.startdDate).getDay();
    var startdate = new Date(reminderJson.startdDate).getDate();
    for (var t = new Date(reminderJson.startdDate); t <= new Date(reminderJson.endDate); t.setDate(t.getDate() + 1)) {
      if (reminderJson.frequency == "Daily") {
        tempDates.push(t.toDateString())
      } else if (reminderJson.frequency == "Weekly") {
        if (startday == t.getDay()) {
          tempDates.push(t.toDateString())
        }
      } else if (reminderJson.frequency == "Monthly") {
        if (startdate == t.getDate()) {
          tempDates.push(t.toDateString())
        }
      }
    }
    console.log(tempDates)
    return tempDates;
  }

  validateCalendar() {
    var validDates = false;
    if (this.state.frequency == 'Daily') {
      var timeDiffCount = this.getTimeDifferenceCount('days');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a day.")

      } else {
        validDates = true;
      }
    } else if (this.state.frequency == 'Weekly') {
      var timeDiffCount = this.getTimeDifferenceCount('weeks');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a week.")
      } else {
        validDates = true;
      }
    } else if (this.state.frequency == 'Monthly') {
      var timeDiffCount = this.getTimeDifferenceCount('months');
      if (timeDiffCount < 1) {
        this.alertError("please enter an end date more than a month.")
      } else {
        validDates = true;
      }
    }

    return validDates;
  }

  getTimeDifferenceCount(type) {
    var startDate = this.state.startdDate
    var endDate = this.state.endDate
    var momentSD = moment(startDate, 'D/M/YYYY');
    var momentED = moment(endDate, 'D/M/YYYY');
    var difference = momentED.diff(momentSD, type);
    return difference;
  }

  alertError(err) {
    const { t } = this.props;
    swal({
      text: t(err),
      icon: "warning",
      button: t("ok"),
    })
  }




  render() {
    const { t } = this.props;
    return (
      <Grid container spacing={3} className="gridcontainer">
        <Grid item xs={4} className="">
          <p>{t('Reminder title')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <TextField id="standard-basic" label="" value={this.state.title} onChange={this.handleTextFieldChange} />
        </Grid>
        <Grid item xs={4} className="">
          <p>{t('Start date')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <Calendardatepickerpopup selectedDate={this.state.startdDate} onDateChange={(date) => { this.onDateChange(date, 'start') }}></Calendardatepickerpopup>
        </Grid>
        <Grid item xs={4} className="">
          <p>{t('End date')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <Calendardatepickerpopup selectedDate={this.state.endDate} onDateChange={(date) => { this.onDateChange(date, 'end') }}></Calendardatepickerpopup>
        </Grid>
        {/* <Grid item xs={4} className="">
          <p>{t('Pill Name')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <TextField id="standard-basic" label="" value={this.state.pillName} onChange={this.handleTextpillchanges} />
        </Grid> */}
        <Grid item xs={4} className="">
          <p>{t('Reminder frequency')}</p>
        </Grid>
        <Grid item xs={8} className="w-100">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onChange={this.handleFrequencyChange}
            value={this.state.frequency}
          >
            <MenuItem value={'Daily'}>{t('Daily')}</MenuItem>
            <MenuItem value={'Weekly'}>{t('Weekly')}</MenuItem>
            <MenuItem value={'Monthly'}>{t('Monthly')}</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={4} className="">
          <p>{t('Reminder time')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <Calendartimepicker selectedDate={this.state.time} onTimeChange={(time) => { this.onTimeChange(time) }}></Calendartimepicker>
        </Grid>
        <Grid item xs={4} className="">
          <p>{t('Reminder description')}</p>
        </Grid>
        <Grid item xs={8} className="">
          <TextField
            id="standard-multiline-static"
            label=""
            multiline
            rows={4}
            defaultValue=""
            value={this.state.description}
            onChange={this.handleTextDescriptionChange}
          />
        </Grid>
        <Grid item xs={12} className="mb-20px">
          <p className="zero p-10px pb-15px text-center">
            <Button variant="contained" style={{ color: "#fff", background: this.props.componentbgcolor }} onClick={() => { this.setReminder() }}>{this.state.editFlag ? t("Update Reminder") : t("Set Reminder")}</Button>
          </p>
        </Grid>
      </Grid>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    activeTabObj: storeState.activeTabObj,
    componentbgcolor: storeState.componentbgcolor
  };
};


const transSerives = withTranslation()(UserSpecificCalendar);
const ThemeServices = withTheme(transSerives);
const routeServices = withRouter(ThemeServices);
export default connect(mapStateToProps, { setactiveTabObj })(routeServices);
